import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'date-range-picker',
  templateUrl: './range-picker.component.html',
  styleUrls: ['./range-picker.component.scss'],
  standalone: false
})
export class RangePickerComponent implements OnInit, OnChanges {
  @Input() public interval: number = 1;

  @Output() public rangeSelected: EventEmitter<{
    startUTC: string;
    endUTC: string;
    intervalDays: number;
  }> = new EventEmitter();

  public open: boolean = false;
  public startDate!: string;
  public endDate!: string;

  public ngOnInit(): void {
    this.setDefaults();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['interval'] && !changes['interval'].firstChange) {
      this.setDefaults();
    }
  }

  private setDefaults(): void {
    const now: Date = new Date();
    this.endDate = now.toISOString();

    const past: Date = new Date(now.getTime() - this.interval * 24 * 60 * 60 * 1000);
    this.startDate = past.toISOString();
    const msPerDay: number = 24 * 60 * 60 * 1000;
    const intervalDays: number = Math.round((now.getTime() - past.getTime()) / msPerDay);
  
    this.rangeSelected.emit({
      startUTC: this.startDate,
      endUTC: this.endDate,
      intervalDays,
    });
  }

  public onStartChange(e: CustomEvent): void {
    this.startDate = e.detail.value;
    if (this.endDate && new Date(this.endDate) < new Date(this.startDate)) {
      this.endDate = this.startDate;
    }
    this.emitRange();
  }

  public onEndChange(e: CustomEvent): void {
    this.endDate = e.detail.value;
    this.emitRange();
  }

  public confirm(): void {
    // this.emitRange();
    this.open = false;
  }

  private emitRange(): void {
    if (!this.startDate || !this.endDate) return;

    const startMs: number = new Date(this.startDate).getTime();
    const endMs: number = new Date(this.endDate).getTime();
    const msPerDay: number = 24 * 60 * 60 * 1000;
    const intervalDays: number = Math.round((endMs - startMs) / msPerDay);

    this.rangeSelected.emit({
      startUTC: new Date(this.startDate).toISOString(),
      endUTC: new Date(this.endDate).toISOString(),
      intervalDays,
    });
  }

  public cancel(): void {
    this.open = false;
  }

  public clear(evt: MouseEvent): void {
    evt.stopPropagation();
    this.setDefaults();
    this.rangeSelected.emit({ startUTC: '', endUTC: '', intervalDays: 0 });
  }

  public formatDisplay(start: string, end: string): string {
    const format = (date: Date): string => {
      const pad = (n: number): string => n.toString().padStart(2, '0');
      const day = pad(date.getDate());
      const month = pad(date.getMonth() + 1);
      const year = date.getFullYear().toString().slice(-2);
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
  
      return `${day}-${month}-${year}:${hours}:${minutes}`;
    };
  
    return `${format(new Date(start))} — ${format(new Date(end))}`;
  }
  
}
